export const UTILS__COMMON__delay = ms => new Promise(resolve => setTimeout(resolve, ms))

export const UTILS__COMMON__KEYS_CHECKER = (func, codes = []) => {
    let pressed = new Set()
    document.addEventListener('keydown', evt => {
        pressed.add(evt.code)
        let success = false
        for (const codesItem of codes) {
            let includes = true
            for (const eventCode of codesItem) {
                if (!pressed.has(eventCode)) {
                    includes = false
                    break
                }
            }
            if (includes) {
                success = true
                break
            }
        }
        if (success) {
            pressed.clear()
            func()
        }
    })
    document.addEventListener('keyup', evt => {
        pressed.delete(evt.code)
    })
}

export const convertArrayToObject = (array, key) => {
    const initialValue = {}
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item,
        }
    }, initialValue)
}

export const checkIsDefined = array => {
    let isErr = false
    for (const item of array) {
        if (typeof item === 'undefined') {
            isErr = true
            break
        }
    }
    return !isErr
}
